<svg width='15' height='15'>
  <polygon points='0, 0, 15, 0, 15, 15' />
</svg>
